import { get } from "../../utils/object-helpers";
import { changeFileExtension } from "./image-url-builder";

$ {
    const { URL, title = "", imageSize, ...attributes } = input;
    const jpegImageUrl = changeFileExtension(URL, "jpg", imageSize);
    const webpImageUrl = changeFileExtension(URL, "webp", imageSize);
    const imageAttributes = {
        ...attributes,
        src: jpegImageUrl,
        title,
    };
    if (!input.alt && input.title) {
        imageAttributes.alt = input.title;
    }
    if (input.noAltTitle === true) {
        imageAttributes.alt = "";
        delete imageAttributes.title;
    }
}

<if(imageAttributes.src)>
  <picture class="str-image">
    <if(webpImageUrl)>
      <source srcset=webpImageUrl type="image/webp">
    </if>
    <img ...imageAttributes>
  </picture>
</if>
